export { EmbedRender } from './EmbedRender';
